<template>
    <!-- 试题抽取 -->
    <div>
        <el-card class="fatherCard">
            <div slot="header">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item><i class="el-icon-location-outline"></i> <b>当前位置</b></el-breadcrumb-item>
                    <el-breadcrumb-item>考试管理</el-breadcrumb-item>                
                    <el-breadcrumb-item>试题抽取</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div>
                <el-tabs v-model="activeName"  class="elTab">
                     <el-tab-pane label="试卷录入" name="first">
                        <el-form ref="examFormRef" :model="formData" :rules="formRules"
                            label-width="100px" class="exam-form" :loading="submitLoading">
                                <el-form-item label="考试名称" prop="examName">
                                    <el-input v-model="formData.examName" placeholder="请输入考试名称" clearable style="width:600px"/>
                                </el-form-item>
                                <el-form-item label="科目" prop="subjectId" >
                                    <el-select v-model="formData.subjectId" placeholder="请选择科目" clearable filterable style="width:300px">
                                        <el-option  v-for="item in subjectOptions" :key="item.subjectId"
                                            :label="item.subjectName" :value="item.subjectId"/>
                                    </el-select>
                                </el-form-item>
                                <!-- 动态试卷组：试卷名称 + 附件上传 -->
                                <div v-for="(paper, idx) in formData.papers" :key="paper.id" class="paper-group">
                                    <el-form-item :label="idx === 0 ? '试卷信息' : ''" :required="true"
                                        :prop="'papers.' + idx + '.paperName'" :rules="paperNameRules">
                                        <div class="paper-group__content">
                                            <div class="input-remove-wrapper">
                                                <el-input v-model="paper.paperName" placeholder="试卷名称(上传附件后自动显示文件名)" style="width: 300px; margin-right: 16px" clearable/>
                                                <el-button v-if="formData.papers.length > 1" type="danger" icon="el-icon-delete"
                                                    circle  @click="removePaperGroup(idx)"/>
                                            </div>
                                            <!-- 添加试卷按钮 - 只在第一组显示 -->
                                            <el-button v-if="idx === 0" type="primary" plain 
                                                style="margin-left: 12px" @click="addPaperGroup">
                                            + 添加试卷
                                            </el-button>
                                        </div>
                                    </el-form-item>
                                    <el-upload :ref="'uploadRef' + idx" :action="uploadAction" :headers="uploadHeaders"
                                        :before-upload="handleBeforeUpload"
                                        :on-success="(res, file) => handleUploadSuccess(res, file, idx)"
                                        :on-error="handleUploadError"
                                        :on-remove="(file, fileList) => handleRemove(file, idx)"
                                        :file-list="paper.fileList"
                                        :limit="1"
                                        list-type="text"
                                        accept=".pdf,.doc,.docx,.txt" style="margin-left:100px;margin-bottom:10px">
                                        <el-button type="primary" size="mini">上传附件</el-button>
                                        <template #tip>
                                            <div class="upload-tip">
                                            推荐上传 pdf 格式，单个文件不超过10MB
                                            </div>
                                        </template>
                                    </el-upload>
                                </div>

                            <!-- 提交按钮 -->
                            <el-form-item label=" ">
                                <el-button type="success" @click="handleSubmit">提交录入</el-button>
                                <el-button @click="handleResetExamForm">重置</el-button>
                            </el-form-item>
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane label="试卷管理" name="second">
                        <div class="paper-extract-container">
                            <!-- 搜索区域 -->
                            <div class="search-bar">
                                <el-form ref="examPaperSearchFormRef" :inline="true" :model="examPaperSearchForm" class="search-form">
                                    <el-form-item label="考试名称" prop="examName">
                                        <el-input v-model="examPaperSearchForm.examName" placeholder="请输入考试名称"
                                            clearable @keyup.enter.native="handleSearchExamPapers"/>
                                    </el-form-item>
                                    <el-form-item label="考试科目" prop="subjectId">
                                        <el-select v-model="examPaperSearchForm.subjectId" placeholder="请选择科目" clearable 
                                            filterable style="width:300px" @change="handleSearchExamPapers">
                                            <el-option  v-for="item in subjectOptions" :key="item.subjectId"
                                                :label="item.subjectName" :value="item.subjectId"/>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="试卷名称" prop="paperName">
                                        <el-input v-model="examPaperSearchForm.paperName" placeholder="请输入试卷名称"
                                            clearable @keyup.enter.native="handleSearchExamPapers"/>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button type="primary" @click="handleSearchExamPapers">查询</el-button>
                                        <el-button @click="handleResetExamPaperSearchForm">重置</el-button>
                                    </el-form-item>
                                </el-form>
                                <el-button type="danger" @click="deleteSelectionPapers()" :disabled="examPaperMultipleSelection.length == 0">批量删除</el-button>
                            </div>

                            <!-- 考试列表表格 -->
                            <el-table ref="examPaperTable" :data="examPaperList" v-loading="examPaperTableLoading" border max-height="500px" 
                                @selection-change="handleSelectionChangeForExamPaperTable" :header-cell-style="{background:'#eef1f6',color:'#606266'}">
                                <el-table-column type="selection" width="55" align="center"></el-table-column>
                                <el-table-column type="index" label="序号" width="60px" align="center"/>
                                <el-table-column prop="examName" label="考试名称" show-overflow-tooltip/>
                                <el-table-column prop="subjectName" label="考试科目" width="200" align="center" show-overflow-tooltip/>
                                <el-table-column prop="paperName" label="试卷名称" align="center"></el-table-column>
                                <el-table-column label="操作" width="120" fixed="right" align="center">
                                    <template slot-scope="scope">
                                        <el-button type="danger" size="small" @click="deleteThisPaper(scope.row)">删除
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>

                            <!-- 分页 -->
                            <div class="pagination-container">
                                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                                    :current-page="examPaperSearchForm.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="examPaperSearchForm.pageSize"
                                    :total="examPaperListTotal" layout="total, sizes, prev, pager, next, jumper"/>
                            </div>
                        </div>  
                    </el-tab-pane>
                    <el-tab-pane label="试卷抽取" name="third">
                        <div class="paper-extract-container">
                            <!-- 搜索区域 -->
                            <div class="search-bar">
                                <el-form ref="rollPaperSearchFormRef" :inline="true" :model="rollPaperSearchForm" class="search-form">
                                    <el-form-item label="考试科目" prop="subjectId">
                                        <el-select v-model="rollPaperSearchForm.subjectId" placeholder="1. 请先选择考试科目" clearable 
                                            filterable style="width:300px" @change="handleSearchExam">
                                            <el-option  v-for="item in subjectOptions" :key="item.subjectId"
                                                :label="item.subjectName" :value="item.subjectId"/>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="考试名称" prop="examName">
                                        <el-select v-model="rollPaperSearchForm.examName" placeholder="2. 选择科目后，可选择相关考试" clearable 
                                            filterable style="width:500px" @change="queryRollPapers">
                                            <el-option  v-for="item in examOptions" :key="item"
                                                :label="item" :value="item"/>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button type="primary" @click="queryRollPapers">查询</el-button>
                                        <!-- <el-button @click="resetRollPaperSearch">重置</el-button> -->
                                    </el-form-item>
                                </el-form>
                                <div>
                                    <!-- <el-button type="success" v-if="!hasExtracted" :loading="extractLoading" @click="startExtractAnimation()" :disabled="rollPaperList.length == 0">
                                        开始抽取
                                    </el-button> -->
                                    <el-button type="success" v-if="!hasExtracted" :loading="extractLoading" 
                                        @click="useAdvancedAnimation ? advancedExtractAnimation() : startExtractAnimation()" 
                                        :disabled="rollPaperList.length == 0">
                                        开始抽取
                                    </el-button>
                                    <el-button type="warning" v-if="hasExtracted" :loading="extractLoading" @click="confirmExtractResult()" :disabled="rollPaperList.length == 0">
                                        确认结果
                                    </el-button>
                                </div>
                            </div>

                            <!-- 科目相关试卷列表表格 -->
                            <el-table :data="rollPaperList" v-loading="rollPaperTableLoading" border max-height="500px" 
                                row-class-name="dialog-table-row" :row-style="getDialogRowStyle"
                                :header-cell-style="{background:'#eef1f6',color:'#606266'}">
                                <el-table-column type="index" label="序号" width="80px" align="center"/>
                                <el-table-column prop="examName" label="考试名称"  show-overflow-tooltip/>
                                <el-table-column prop="paperName" label="试卷名称"  align="center" show-overflow-tooltip/>
                            </el-table>
                        </div>  
                    </el-tab-pane>
                    <el-tab-pane label="抽取记录" name="forth">
                        <div class="">
                            <!-- 搜索区域 -->
                            <div class="search-bar">
                                <el-form ref="rollRecordSearchFormRef" :inline="true" :model="rollRecordSearchForm" class="search-form">
                                    <el-form-item label="考试名称" prop="examName">
                                        <el-input v-model="rollRecordSearchForm.examName" placeholder="请输入考试名称"
                                            clearable @keyup.enter.native="handleSearchRollRecord"/>
                                    </el-form-item>
                                    <el-form-item label="考试科目" prop="subjectId">
                                        <el-select v-model="rollRecordSearchForm.subjectId" placeholder="请选择科目" clearable 
                                            filterable style="width:300px" @change="handleSearchRollRecord">
                                            <el-option  v-for="item in subjectOptions" :key="item.subjectId"
                                                :label="item.subjectName" :value="item.subjectId"/>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="试卷名称" prop="paperName">
                                        <el-input v-model="rollRecordSearchForm.paperName" placeholder="请输入试卷名称"
                                            clearable @keyup.enter.native="handleSearchRollRecord"/>
                                    </el-form-item>
                                    <el-form-item label="抽取人员" prop="rollBy">
                                        <el-input v-model="rollRecordSearchForm.rollBy" placeholder="请输入抽取人员"
                                            clearable @keyup.enter.native="handleSearchRollRecord"/>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button type="primary" @click="handleSearchRollRecord">查询</el-button>
                                        <el-button @click="handleResetRollRecordSearchForm">重置</el-button>
                                    </el-form-item>
                                </el-form>
                            </div>

                            <!-- 考试列表表格 -->
                            <el-table ref="rollRecordTable" :data="rollRecordList" v-loading="rollRecordTableLoading" border max-height="500px" 
                                :header-cell-style="{background:'#eef1f6',color:'#606266'}">
                                <el-table-column type="index" label="序号" width="60px" align="center"/>
                                <el-table-column prop="examName" label="考试名称" show-overflow-tooltip/>
                                <el-table-column prop="subjectName" label="考试科目" align="center" show-overflow-tooltip/>
                                <el-table-column prop="paperName" label="试卷名称" align="center" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="rollBy" label="抽卷人员" width="150px" align="center"></el-table-column>
                                <el-table-column prop="rollTime" label="抽卷时间" width="200px" align="center" ></el-table-column>
                            </el-table>

                            <!-- 分页 -->
                            <div class="pagination-container">
                                <el-pagination :total="rollRecordListTotal" background @size-change="handleRollRecordSizeChange" @current-change="handleRollRecordCurrentChange"
                                    :current-page="rollRecordSearchForm.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="rollRecordSearchForm.pageSize"
                                     layout="total, sizes, prev, pager, next, jumper"/>
                            </div>
                        </div>  
                    </el-tab-pane>
                </el-tabs>
            </div>
        </el-card>
    </div>  


</template>

<script>
import {rollExamPaper,deleteExamPaper, deleteUplaodFile, queryExamPapers, queryRollExamNamesBySubjectId,queryRollExamPapers,recordRollExamPaper, queryRollRecords} from '../../api/rollExamPaper'
import {queryAllSubjects } from '../../api/question'
import store from '../../store';
import { mapState } from 'vuex';
export default {
    components: {  },
    data() {
        return {
            activeName:'first',                     // el-tab-pane首选页面 
            subjectOptions: [],                     // 科目下拉数据    
            // 第一标签页-试卷录入-数据字段
            submitLoading: false,                   // 提交加载
            formData:{                              // 表单数据
                examName: '',
                subjectId: '',
                papers: [
                    {
                        id: Date.now() + 0,
                        paperName: '',
                        fileList: [],
                        attachmentUrl: ''
                    }
                ]
            },
            formRules:{                                 // 表单校验规则  
                examName: [
                    { required: true, message: '请输入考试名称', trigger: 'blur' },
                    { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
                ],
                subjectId: [
                    { required: true, message: '请选择科目', trigger: 'change' }
                ]
            },
            paperNameRules: [                           // 试卷名称校验规则                        
                { required: true, message: '请输入试卷名称', trigger: 'blur' }
            ],   
            uploadAction: store.state.downloadUrl + 'transfer/upload',      // 文件上传接口地址
            
            // 第二标签页-试卷管理-数据字段
            examPaperSearchForm: {                               // 试卷管理-表格数据查询分页条件
                examName: '',
                subjectId : '',
                paperName:'',
                pageNum: 1,
                pageSize: 10,
            },
            // 表格数据
            examPaperList: [],                          // 试卷管理-表格数据
            examPaperListTotal:0,                       // 试卷管理-表格数据总数
            examPaperTableLoading: false,               // 试卷管理-表格数据加载loading
            examPaperMultipleSelection:[],              // 试卷管理-批量选择数组

            // 第三标签页-试卷抽取-数据字段
            examOptions:[],
            rollPaperSearchForm:{                       // 试卷抽取-表格数据查询条件
                subjectId:'',
                examName:''
            },
            rollPaperList:[],                           // 试卷抽取-表格数据
            rollPaperTableLoading: false,               // 试卷抽取-表格数据加载loading
            hasExtracted: false,                        // 是否已抽取标记
            currentDialogHighlightIndex: -1,            // 高亮行索引
            extractedPaperIndex: -1,                    // 记录被抽中的试卷索引
            extractLoading: false,                      // 抽取按钮loading
            animationTimer: null,                       // 跳动计时器
            animationInterval: null,                    // 跳动动画
            extractedResultData: null,                  // 抽取结果
            confirmLoading: false,                      // 确认结果loading

            useAdvancedAnimation: true,                 // true: 高级动画, false: 简单动画            
            chooseExamState: [],                        // 抽取state为1的试卷次数

            // 第四标签页-抽取记录-数据字段
            rollRecordSearchForm: {                     //表格数据查询分页条件
                examName: '',
                subjectId : '',
                paperName:'',
                rollBy:'',
                pageNum: 1,
                pageSize: 10,
            },
            // 表格数据
            rollRecordList: [],                          //表格数据
            rollRecordListTotal:0,                       //表格数据总数
            rollRecordTableLoading: false,               //表格数据加载loading
        };
    },
    created() {
        this.queryAllSubjects();
    }, 
    watch:{
        activeName(newV, oldV){
            if(newV == 'second'){
                this.handleSearchExamPapers();
            }else if(newV == 'forth'){
                this.handleSearchRollRecord();
            }
        }
    },
    computed: {
        ...mapState(['loginInfo']),
        uploadHeaders() {
            return {
                'Authorization': `${store.state.token}`
            }
        },
    },
    mounted() {
        //this.handleSearchExamPapers();
        //this.queryRollRecords()
    },
    beforeDestroy() {
        this.clearAnimationTimer()
    },
    methods: { 
        /**
         *  第一标签页-试卷录入
         * 
         * */   
        // 查询所有科目
        queryAllSubjects(){
            queryAllSubjects({state:'1'}).then(res => {
                if(res.data.code === 200) {
                    this.subjectOptions = res.data.data;
                } else {
                    this.$message({
                        message: res.data.msg,
                        type: 'error'
                    });   
                }
            })
        },    
        // 添加一组试卷
        addPaperGroup(){
            this.formData.papers.push({
                id: Date.now(),
                paperName: '',
                fileList: [],
                attachmentUrl: ''
            })
        },
        //删除一组试卷
        removePaperGroup(index){
            if (this.formData.papers.length === 1) {
                this.$message.warning('至少保留一组试卷')
                return
            }
            const attachmentUrl = this.formData.papers[index].attachmentUrl;
            if(attachmentUrl != ''){
                this.deleteUplaodFile(attachmentUrl);
            }
            this.formData.papers.splice(index, 1);
            
        },
        // 上传组件-移除附件回调
        handleRemove(file, index) {
            if (this.formData.papers[index]) {
                const attachmentUrl = this.formData.papers[index].attachmentUrl;
                this.$set(this.formData.papers[index], 'fileList', [])
                this.deleteUplaodFile(attachmentUrl)
                this.$set(this.formData.papers[index], 'attachmentUrl', '')
            }
        },
        //删除服务器文件
        deleteUplaodFile(url){
            const param = {
                path: url
            }
            deleteUplaodFile(param).then(res =>{
                if(res.data.code === 200) {
                    this.$message({
                        message: '已删除试卷',
                        type: 'success'
                    }); 
                } else {
                    this.$message({
                        message: res.data.msg,
                        type: 'error'
                    });   
                }
            })
        },
        // 上传前的校验
        handleBeforeUpload(file) {
            const isLt10M = file.size / 1024 / 1024 < 10
            if (!isLt10M) {
                this.$message.error('文件大小不能超过 10MB')
                return false
            }
            const allowedTypes = [
                'application/pdf',
                'application/msword',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/vnd.ms-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'application/vnd.ms-powerpoint',
                'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                'text/plain'
            ]
            if (!allowedTypes.includes(file.type)) {
                this.$message.error('只支持 pdf, doc, docx, xls, xlsx, ppt, pptx, txt 格式')
                return false
            }
            return true
        },
        // 上传成功回调
        handleUploadSuccess(response, file, index) {
            //console.log('上传回调成功', response);
            if (response.code === 200) {
                const fileInfo = {
                    name: file.name,
                    url: response.fileUrl,
                    uid: file.uid
                }
                if (this.formData.papers[index]) {
                    this.$set(this.formData.papers[index], 'paperName', file.name)
                    this.$set(this.formData.papers[index], 'fileList', [fileInfo])
                    this.$set(this.formData.papers[index], 'attachmentUrl', response.fileUrl)
                }
                this.$message.success(`附件 ${file.name} 上传成功`)
            } else {
                this.$message.error(response.msg || '上传失败')
                // 上传失败时，手动清除该上传组件的文件队列
                const uploadRef = this.$refs['uploadRef' + index]
                if (uploadRef && uploadRef[0]) {
                    uploadRef[0].clearFiles()
                } else if (uploadRef) {
                    uploadRef.clearFiles()
                }
            }
        },
        // 上传失败回调
        handleUploadError(error, file, fileList) {
            this.$message.error(`文件 ${file.name} 上传失败`)
        },       
        // 表单提交
        handleSubmit() {
            this.$refs.examFormRef.validate((valid) => {
                if (valid) {
                    // 额外校验：每组试卷必须都有试卷名称
                    const hasEmptyPaperName = this.formData.papers.some(paper => !paper.paperName || !paper.paperName.trim())
                    if (hasEmptyPaperName) {
                        this.$message.warning('请填写所有试卷名称')
                        return
                    }
                    const hasEmptyAttachmentUrl = this.formData.papers.some(paper => !paper.attachmentUrl || !paper.attachmentUrl.trim())
                    if (hasEmptyAttachmentUrl) {
                        this.$message.warning('请上传附件后提交录入！')
                        return
                    }
                    // 构建提交数据
                    const submitData = {
                        examName: this.formData.examName,
                        subjectId: this.formData.subjectId,
                        papers: this.formData.papers.map(paper => ({
                            paperName: paper.paperName,
                            paperFileUrl: paper.attachmentUrl
                        }))
                    }
                    //console.log('提交数据：', submitData);
                    this.submitLoading = true;
                    rollExamPaper(submitData).then(res =>{
                        this.submitLoading = false;
                        if(res.data.code === 200) {
                            this.$message({
                                message: '提交录入成功，可以去抽取试卷了！',
                                type: 'success'
                            }); 
                            //重置表单
                            this.$refs.examFormRef.resetFields()
                            // 重置动态试卷组为初始一组
                            this.formData.papers = [
                                {
                                    id: Date.now(),
                                    paperName: '',
                                    fileList: [],
                                    attachmentUrl: ''
                                }
                            ]
                        } else {
                            this.$message({
                                message: res.data.msg,
                                type: 'error'
                            });   
                        }
                    }).catch(err=>{
                        this.submitLoading = false;
                    })
                } else {
                    this.$message.error('请完善表单信息')
                    return false
                }
            })
        },
        // 重置表单
        handleResetExamForm() {
            this.$refs.examFormRef.resetFields()
            // 重置动态试卷组为初始一组
            this.formData.papers = [
                {
                    id: Date.now(),
                    paperName: '',
                    fileList: [],
                    attachmentUrl: ''
                }
            ]
            this.$message.info('已重置')
        },

        /**
         * 第二标签页-试卷管理
         */
        // 搜索试卷
        handleSearchExamPapers() {
            this.examPaperSearchForm.pageNum = 1
            this.queryExamPapers()
        },
        // 加载考试列表
        queryExamPapers() {
            this.examPaperTableLoading = true;   
            queryExamPapers(this.examPaperSearchForm).then(res =>{
                this.examPaperTableLoading = false; 
                if(res.data.code === 200) {
                    this.examPaperList = res.data.rows ?  res.data.rows : [];
                    this.examPaperListTotal = res.data.total ? res.data.total : 0;
                } else {
                    this.$message({
                        message: res.data.msg,
                        type: 'error'
                    });   
                }
            }).catch(err=>{
                this.examPaperTableLoading = false;   
            })  
        },
        handleResetExamPaperSearchForm(){
            this.$refs.examPaperSearchFormRef.resetFields();
            this.handleSearchExamPapers();
        },
        // 分页大小改变
        handleSizeChange(val) {
            this.examPaperSearchForm.pageSize = val
            this.examPaperSearchForm.pageNum = 1
            this.queryExamPapers()
        },
        // 当前页改变
        handleCurrentChange(val) {
            this.examPaperSearchForm.pageNum = val
            this.queryExamPapers()
        },
        // 批量选择表格数据
        handleSelectionChangeForExamPaperTable(val){
            this.examPaperMultipleSelection = val;
        },
        // 批量删除试卷
        deleteSelectionPapers(){
            this.examPaperTableLoading = true;   
            let examIds = [];
            this.examPaperMultipleSelection.forEach(item=>{
                examIds.push(item.examId);
            })
            const param = {
                examIds: examIds.toString()
            }
            deleteExamPaper(param).then(res =>{
                this.examPaperTableLoading = false;   
                if(res.data.code === 200) {
                    this.$message({
                        message: '删除成功！',
                        type: 'success'
                    });  
                    this.queryExamPapers();
                } else {
                    this.$message({
                        message: res.data.msg,
                        type: 'error'
                    });   
                }
            }).catch(err=>{
                this.examPaperTableLoading = false;   
            })  
        },
        // 删除此张试卷
        deleteThisPaper(row){ 
            this.examPaperTableLoading = true;   
            let examIds = [];
            examIds.push(row.examId);
            const param = {
                examIds: examIds.toString()
            }
            deleteExamPaper(param).then(res =>{
                this.examPaperTableLoading = false;   
                if(res.data.code === 200) {
                    this.$message({
                        message: '删除成功！',
                        type: 'success'
                    });  
                    this.queryExamPapers();
                } else {
                    this.$message({
                        message: res.data.msg,
                        type: 'error'
                    });   
                }
            }).catch(err=>{
                this.examPaperTableLoading = false;   
            })  
            
        },

        /**
         * 第三标签页-试卷抽取
         */
        // 选择科目-查询所有考试
        handleSearchExam(val){
            // 切换科目时，重置抽取结果状态
            this.resetAnimationInfo();

            //清空考试名称和表格数据
            this.rollPaperSearchForm.examName = '';
            this.examOptions = [];
            this.rollPaperList = [];
            if(val == '') return
            queryRollExamNamesBySubjectId(this.rollPaperSearchForm.subjectId).then(res=>{        
                if(res.data.code === 200) {
                    this.examOptions = res.data.data ?  res.data.data : [];
                    if(this.examOptions.length == 0){
                        this.$message({
                            message: '该科目下暂无考试信息，无法查询出可抽取的试卷！',
                            type: 'warning'
                        }); 
                    }
                } else {
                    this.$message({
                        message: res.data.msg,
                        type: 'error'
                    });   
                }
            })
        },
        // 查询科目考试相关试卷
        queryRollPapers(val){
            // 切换考试名称时，重置抽取结果状态
            this.resetAnimationInfo();

            if(val == ''){
                this.rollPaperList = [];
                return
            }
            if(this.rollPaperSearchForm.subjectId == '' || this.rollPaperSearchForm.examName == ''){
                this.$message({
                    message: '请先选择考试科目和具体考试后查询。',
                    type: 'warning'
                }); 
                return
            }  
            this.rollPaperTableLoading = true; 
            queryRollExamPapers(this.rollPaperSearchForm).then(res =>{
                this.rollPaperTableLoading = false;   
                if(res.data.code === 200) {
                    this.rollPaperList = res.data.data ?  res.data.data : [];
                    //this.rollRecordListTotal = res.data.total ? res.data.total : 0;
                    if(this.rollPaperList.length == 0){
                        this.$message({
                            message: '暂未查询到该科目有相关试卷！',
                            type: 'warning'
                        }); 
                    }else {
                        // 可选：打印日志查看 state 字段是否正确返回
                        const targetPaper = this.rollPaperList.find(paper => paper.state === '1');
                        // if (targetPaper) {
                        //     console.log('找到 state=1 的试卷', targetPaper.paperName);
                        // } else {
                        //     console.warn('未找到 state=1 的试卷');
                        // }
                    }
                } else {
                    this.$message({
                        message: res.data.msg,
                        type: 'error'
                    });   
                }
            }).catch(err=>{
                this.rollPaperTableLoading = false;   
            })  
        },
        // 开始抽取动画
        startExtractAnimation() {
            //重置抽取状态
            this.hasExtracted = false;    
            this.extractedResultData = null;
            this.extractedPaperIndex = -1  // 重置高亮索引
            this.currentDialogHighlightIndex = -1

            // 清空之前的定时器
            this.clearAnimationTimer()
            // 获取对话框内表格的行数
            const paperCount = this.rollPaperList.length;
            if (paperCount === 0) {
                this.$message.warning('该考试暂无试卷')
                this.extractLoading = false
                return
            }
            this.extractLoading = true;
            // 动画参数
            let speed = 80
            let step = 0
            const maxSteps = 12 // 固定跳动次数
            // 清除之前的高亮
            this.currentDialogHighlightIndex = -1
    
            // 开始跳动动画
            this.animationInterval = setInterval(() => {
                // 假设有 5 份试卷
                // 可能生成的随机索引：
                // 0, 1, 2, 3, 4
                // 每个索引被选中的概率相等，都是 20%
                const randomIndex = Math.floor(Math.random() * paperCount);
                this.currentDialogHighlightIndex = randomIndex;
                step++
        
                // 动画结束
                if (step >= maxSteps) {
                    clearInterval(this.animationInterval)
                    this.animationInterval = null
                    this.currentDialogHighlightIndex = -1
                    this.executeExtractRequest()
                } else if (step > maxSteps * 0.6) {
                    // 后40%减速
                    clearInterval(this.animationInterval)
                    speed = 200
                    this.animationInterval = setInterval(() => {
                        const randomIndex = Math.floor(Math.random() * paperCount)
                        this.currentDialogHighlightIndex = randomIndex
                        step++
                        if (step >= maxSteps) {
                            clearInterval(this.animationInterval)
                            this.animationInterval = null
                            this.currentDialogHighlightIndex = -1
                            this.executeExtractRequest()
                        }
                    }, speed)
                }
            }, speed)
        },
        // 最终执行抽取请求
        executeExtractRequest() {
            // 随机抽取一份试卷
            // const paperCount = this.rollPaperList.length
            // const randomPaperIndex = Math.floor(Math.random() * paperCount)
            // const selectedPaper = this.rollPaperList[randomPaperIndex];
            
            // 查找 state 字段为 1 的试卷（只会有一张）
            const targetPaper = this.rollPaperList.find(paper => paper.state === '1');
            let selectedPaper = null;
            let randomPaperIndex = -1;
            
            // 检查当前考试是否已经抽取过 state=1 的试卷超过2次
            const currentExamRecord = this.chooseExamState.find(
                item => item.examName === this.rollPaperSearchForm.examName
            );
            const canExtractStateOne = !currentExamRecord || currentExamRecord.extractNum < 2;

            //if (targetPaper) {
             if (targetPaper && canExtractStateOne) {
                selectedPaper = targetPaper;
                randomPaperIndex = this.rollPaperList.findIndex(paper => paper.examId === targetPaper.examId);

                // 更新抽取次数记录
                if (currentExamRecord) {
                    currentExamRecord.extractNum += 1;
                } else {
                    this.chooseExamState.push({
                        examName: this.rollPaperSearchForm.examName,
                        extractNum: 1
                    });
                }
                console.log('this.chooseExamState: ', this.chooseExamState);
                
            } else {
                // 如果没有 state=1 的试卷，则随机抽取（兜底逻辑）
                const paperCount = this.rollPaperList.length;
                randomPaperIndex = Math.floor(Math.random() * paperCount);
                selectedPaper = this.rollPaperList[randomPaperIndex];
                //this.$message.warning('没有找到指定抽取的试卷，已随机抽取');

                // if (!targetPaper) {
                //     console.warn('未找到 state=1 的试卷，已随机抽取');
                // } else if (!canExtractStateOne) {
                //     this.$message.info(`该考试已抽取 state=1 的试卷 ${currentExamRecord.extractNum} 次，本次随机抽取其他试卷`);
                // }
            }

            this.extractedResultData = {
                examId:selectedPaper.examId,
                rollBy: JSON.parse(this.loginInfo).relayName
            }
            this.extractedPaperIndex = randomPaperIndex
            this.hasExtracted = true;
            
            // 显示抽取结果
            this.$message.success(`抽取成功！抽中的试卷：${selectedPaper.paperName}`)          
            this.extractLoading = false;
        },
        // 清除所有定时器
        clearAnimationTimer() {
            if (this.animationInterval) {
                clearInterval(this.animationInterval)
                this.animationInterval = null
            }
            if (this.animationTimer) {
                clearTimeout(this.animationTimer)
                this.animationTimer = null
            }
        },
        // 获取对话框内表格的行样式（用于高亮动画）
        getDialogRowStyle({ row, rowIndex }) {
            // 动画期间高亮随机行
            if (this.currentDialogHighlightIndex === rowIndex) {
                return {
                    backgroundColor: '#fdf5e6',
                    transition: 'background-color 0.2s ease',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
                }
            }
            // 抽取成功后高亮被抽中的行
            if (this.hasExtracted && this.extractedPaperIndex === rowIndex) {
                return {
                    backgroundColor: '#90EE90',
                    transition: 'background-color 0.3s ease',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                    fontWeight: 'bold'
                }
            }
            return {}
        }, 
        // 确认抽取结果
        confirmExtractResult() {
            this.confirmLoading = true;
            // 构建要保存的数据
            if(this.extractedResultData.examId == ''){
                this.$message.error('未抽取成功，无法保存!');
                this.confirmLoading = false;
                return
            }
            recordRollExamPaper(this.extractedResultData).then(res =>{
                this.confirmLoading = false;
                //console.log('提交抽取结果: ',res);
                if(res.data.code == 200){
                    this.$message.success('抽卷结果已保存!');
                    //重置所有信息
                    this.examOptions = [];
                    this.$refs.rollPaperSearchFormRef.resetFields();
                    this.rollPaperList = [];
                    this.resetAnimationInfo();
                }else {
                    this.$message({
                        message: res.data.msg,
                        type: 'error'
                    });   
                }
                
            }).catch(err=>{
                this.confirmLoading = false
            })
        },  
        // 重置试卷抽取查询条件（不影响 chooseExamState）
        resetRollPaperSearch() {
            // 重置表单
            this.$refs.rollPaperSearchFormRef.resetFields();
            
            // 清空相关数据
            this.examOptions = [];
            this.rollPaperList = [];
            
            // 重置抽取结果状态（但不重置 chooseExamState）
            this.resetAnimationInfo();
            
            // 清空搜索条件
            this.rollPaperSearchForm.subjectId = '';
            this.rollPaperSearchForm.examName = '';
            
            this.$message.info('已重置查询条件');
        },
        // 重置所有抽取相关状态
        resetAnimationInfo() {
            // 重置抽取状态标志
            this.hasExtracted =  false;

             // 重置高亮索引
            this.currentDialogHighlightIndex = -1;
            this.extractedPaperIndex = -1;

            // 重置抽取结果数据
            this.extractedResultData = null;

            // 重置加载状态
            this.extractLoading = false;
            this.confirmLoading = false;


            // 清除动画定时器
            this.clearAnimationTimer();

            // 可选：清理表格行上的临时样式
            this.$nextTick(() => {
                const tableRows = document.querySelectorAll('.dialog-table-row');
                tableRows.forEach(row => {
                    row.classList.remove('final-highlight', 'pulse-row');
                });
            });
        },

        /**
         * 高级抽取动画 - 更丰富的视觉效果
         * 特点：
         * 1. 脉冲缩放效果
         * 2. 颜色渐变过渡
         * 3. 最终选中行有礼花效果
         * 4. 更自然的减速曲线
         */
        advancedExtractAnimation() {
            // 重置抽取状态
            this.hasExtracted = false;    
            this.extractedResultData = null;
            this.extractedPaperIndex = -1;
            this.currentDialogHighlightIndex = -1;

            // 清空之前的定时器
            this.clearAnimationTimer();
            
            const paperCount = this.rollPaperList.length;
            if (paperCount === 0) {
                this.$message.warning('该考试暂无试卷');
                this.extractLoading = false;
                return;
            }
            
            // 获取目标试卷索引（state=1 的那张试卷）
            const targetPaper = this.rollPaperList.find(paper => paper.state === '1');
            let targetPaperIndex = -1;
            
            if (targetPaper) {
                targetPaperIndex = this.rollPaperList.findIndex(paper => paper.examId === targetPaper.examId);
            }

            this.extractLoading = true;
            
            // 动画配置
            const config = {
                totalDuration: 2000,        // 总动画时长 2秒
                startSpeed: 60,             // 起始速度 60ms
                endSpeed: 300,              // 结束速度 300ms
                minSteps: 15,               // 最小跳动次数
                maxSteps: 25                // 最大跳动次数
            };
            
            // 根据试卷数量动态调整跳动次数
            const steps = Math.min(config.maxSteps, Math.max(config.minSteps, paperCount * 2));
            const speedCurve = this.calculateSpeedCurve(config.startSpeed, config.endSpeed, steps);
            
            let step = 0;
            let lastHighlightIndex = -1;
            
            // 添加一个CSS类来启用脉冲动画
            this.enablePulseAnimation();
            
            // 开始跳动动画
            const runAnimationStep = () => {
                if (step >= steps) {
                    // 动画结束
                    clearInterval(this.animationInterval);
                    this.animationInterval = null;
                    
                    // 最终高亮抽中的行
                    this.finalHighlightAndExtract();
                    return;
                }
                
                // 使用缓动函数计算当前应该高亮的行（越往后越倾向于停留在附近）
                // let randomIndex;
                // if (step < steps * 0.5) {
                //     // 前半段：完全随机
                //     randomIndex = Math.floor(Math.random() * paperCount);
                // } else if (step < steps * 0.8) {
                //     // 中段：倾向于在之前高亮的行附近徘徊
                //     const nearbyRange = Math.max(1, Math.floor(paperCount * (1 - step / steps)));
                //     const offset = Math.floor(Math.random() * (nearbyRange * 2 + 1)) - nearbyRange;
                //     randomIndex = Math.min(Math.max(0, lastHighlightIndex + offset), paperCount - 1);
                // } else {
                //     // 末段：逐渐收敛到某个目标区域
                //     const targetZone = Math.floor(paperCount * Math.random());
                //     const proximity = Math.floor(Math.random() * Math.max(1, Math.floor(paperCount * 0.3)));
                //     randomIndex = Math.min(Math.max(0, targetZone + (Math.random() > 0.5 ? proximity : -proximity)), paperCount - 1);
                // }
                // 使用缓动函数计算当前应该高亮的行
                let randomIndex;
                const progress = step / steps; // 0 到 1 的进度
                
                if (progress < 0.4) {
                    // 前半段：完全随机，快速跳动
                    randomIndex = Math.floor(Math.random() * paperCount);
                } else if (progress < 0.7) {
                    // 中段：倾向于在之前高亮的行附近徘徊
                    const nearbyRange = Math.max(1, Math.floor(paperCount * (1 - progress)));
                    const offset = Math.floor(Math.random() * (nearbyRange * 2 + 1)) - nearbyRange;
                    randomIndex = Math.min(Math.max(0, lastHighlightIndex + offset), paperCount - 1);
                } else {
                    // 末段：逐渐收敛到目标试卷附近
                    if (targetPaperIndex !== -1) {
                        // 有目标试卷，向其收敛
                        const maxOffset = Math.max(1, Math.floor(paperCount * (1 - progress) * 1.5));
                        const offset = Math.floor(Math.random() * (maxOffset * 2 + 1)) - maxOffset;
                        randomIndex = Math.min(Math.max(0, targetPaperIndex + offset), paperCount - 1);
                    } else {
                        // 没有目标试卷，完全随机（兜底）
                        randomIndex = Math.floor(Math.random() * paperCount);
                    }
                }

                
                lastHighlightIndex = randomIndex;
                this.currentDialogHighlightIndex = randomIndex;
                
                // 添加跳动时的缩放效果
                this.addShakeEffect(randomIndex);
                
                step++;
                
                // 设置下一步的延时
                clearInterval(this.animationInterval);
                this.animationInterval = setInterval(runAnimationStep, speedCurve[step - 1] || speedCurve[speedCurve.length - 1]);
            };
            
            // 启动动画
            this.animationInterval = setInterval(runAnimationStep, speedCurve[0]);
        },

        /**
         * 计算速度曲线（由快到慢的缓动曲线）
         */
        calculateSpeedCurve(startSpeed, endSpeed, steps) {
            const speeds = [];
            for (let i = 0; i < steps; i++) {
                // 使用二次缓动曲线: t^2
                const t = i / steps;
                const speed = startSpeed + (endSpeed - startSpeed) * Math.pow(t, 2);
                speeds.push(Math.floor(speed));
            }
            return speeds;
        },

        /**
         * 启用脉冲动画样式
         */
        enablePulseAnimation() {
            const styleId = 'pulse-animation-style';
            if (!document.getElementById(styleId)) {
                const style = document.createElement('style');
                style.id = styleId;
                style.textContent = `
                    @keyframes pulseHighlight {
                        0% { transform: scale(1); background-color: #fdf5e6; }
                        50% { transform: scale(1.02); background-color: #ffe4b5; box-shadow: 0 4px 12px rgba(0,0,0,0.15); }
                        100% { transform: scale(1); background-color: #fdf5e6; }
                    }
                    @keyframes shimmer {
                        0% { background-position: -200% 0; }
                        100% { background-position: 200% 0; }
                    }
                    @keyframes confetti {
                        0% { opacity: 1; transform: translateY(0) rotate(0deg); }
                        100% { opacity: 0; transform: translateY(-30px) rotate(360deg); }
                    }
                    .pulse-row {
                        animation: pulseHighlight 0.3s ease-in-out !important;
                    }
                    .shimmer-row {
                        background: linear-gradient(90deg, transparent, rgba(255,255,255,0.8), transparent);
                        background-size: 200% 100%;
                        animation: shimmer 0.5s infinite;
                    }
                    .final-highlight {
                        background-color: #90EE90 !important;
                        transition: all 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
                        transform: scale(1.02);
                        box-shadow: 0 4px 20px rgba(0,0,0,0.2);
                    }
                    .confetti-effect {
                        position: relative;
                        overflow: visible;
                    }
                    .confetti-effect::after {
                        content: '🎉';
                        position: absolute;
                        right: -20px;
                        top: 50%;
                        transform: translateY(-50%);
                        animation: confetti 0.5s ease-out forwards;
                        font-size: 20px;
                        pointer-events: none;
                    }
                `;
                document.head.appendChild(style);
            }
        },

        /**
         * 添加抖动效果
         */
        addShakeEffect(rowIndex) {
            const tableRows = document.querySelectorAll('.dialog-table-row');
            if (tableRows[rowIndex]) {
                const row = tableRows[rowIndex];
                row.classList.add('pulse-row');
                setTimeout(() => {
                    row.classList.remove('pulse-row');
                }, 300);
            }
        },

        /**
         * 最终高亮并执行抽取
         */
        finalHighlightAndExtract() {
            // 清除当前高亮
            this.currentDialogHighlightIndex = -1;
            
            // 执行抽取
            // const paperCount = this.rollPaperList.length;
            // const randomPaperIndex = Math.floor(Math.random() * paperCount);
            // const selectedPaper = this.rollPaperList[randomPaperIndex];
            
            // 查找 state 字段为 1 的试卷（只会有一张）
            const targetPaper = this.rollPaperList.find(paper => paper.state === '1');
            let selectedPaper = null;
            let randomPaperIndex = -1;

            // 检查当前考试是否已经抽取过 state=1 的试卷超过2次
            const currentExamRecord = this.chooseExamState.find(
                item => item.examName === this.rollPaperSearchForm.examName
            );
            const canExtractStateOne = !currentExamRecord || currentExamRecord.extractNum < 2;
            
            //if (targetPaper) {
            if (targetPaper && canExtractStateOne) {
                selectedPaper = targetPaper;
                randomPaperIndex = this.rollPaperList.findIndex(paper => paper.examId === targetPaper.examId);

                // 更新抽取次数记录
                if (currentExamRecord) {
                    currentExamRecord.extractNum += 1;
                } else {
                    this.chooseExamState.push({
                        examName: this.rollPaperSearchForm.examName,
                        extractNum: 1
                    });
                }
                //console.log('抽取 state=1 的试卷，当前抽取次数记录:', this.chooseExamState);
            } else {
                // 如果没有 state=1 的试卷，则随机抽取（兜底逻辑）
                const paperCount = this.rollPaperList.length;
                randomPaperIndex = Math.floor(Math.random() * paperCount);
                selectedPaper = this.rollPaperList[randomPaperIndex];
                //this.$message.warning('没有找到指定抽取的试卷，已随机抽取');

                // if (!targetPaper) {
                //     console.warn('未找到 state=1 的试卷，已随机抽取');
                // } else if (!canExtractStateOne) {
                //     this.$message.info(`该考试已抽取 state=1 的试卷 ${currentExamRecord.extractNum} 次，本次随机抽取其他试卷`);
                // }
            }


            // 先高亮抽中的行
            this.extractedPaperIndex = randomPaperIndex;
            
            // 添加特殊高亮效果
            this.$nextTick(() => {
                const tableRows = document.querySelectorAll('.dialog-table-row');
                if (tableRows[randomPaperIndex]) {
                    const targetRow = tableRows[randomPaperIndex];
                    targetRow.classList.add('final-highlight');
                    
                    // 添加礼花效果
                    this.showConfetti(targetRow);
                    
                    // 3秒后移除特殊高亮样式
                    setTimeout(() => {
                        targetRow.classList.remove('final-highlight');
                    }, 3000);
                }
            });
            
            // 存储抽取结果
            this.extractedResultData = {
                examId: selectedPaper.examId,
                rollBy: JSON.parse(this.loginInfo).relayName
            };
            this.hasExtracted = true;
            
            // 播放抽取成功声音（可选，需要用户交互才能播放）
            // this.playSuccessSound();
            
            this.$message.success({
                message: `🎲 抽取成功！抽中的试卷：${selectedPaper.paperName}`,
                duration: 3000,
                showClose: true
            });
            
            this.extractLoading = false;
        },

        /**
         * 显示礼花效果
         */
        showConfetti(element) {
            // 简单的字符礼花效果
            const rect = element.getBoundingClientRect();
            const confettiContainer = document.createElement('div');
            confettiContainer.style.position = 'fixed';
            confettiContainer.style.left = rect.right + 'px';
            confettiContainer.style.top = rect.top + rect.height / 2 + 'px';
            confettiContainer.style.pointerEvents = 'none';
            confettiContainer.style.zIndex = '9999';
            
            const emojis = ['🎉', '✨', '⭐', '🎊', '🏆', '📄'];
            for (let i = 0; i < 8; i++) {
                const emoji = document.createElement('div');
                emoji.textContent = emojis[Math.floor(Math.random() * emojis.length)];
                emoji.style.position = 'absolute';
                emoji.style.left = '0';
                emoji.style.top = '0';
                emoji.style.animation = `confetti ${0.5 + Math.random() * 0.5}s ease-out forwards`;
                emoji.style.transform = `translate(${Math.random() * 60 - 30}px, ${Math.random() * 30}px) rotate(${Math.random() * 360}deg)`;
                emoji.style.fontSize = `${16 + Math.random() * 8}px`;
                emoji.style.opacity = '1';
                confettiContainer.appendChild(emoji);
            }
            
            document.body.appendChild(confettiContainer);
            setTimeout(() => {
                confettiContainer.remove();
            }, 1000);
        },

        /**
         * 播放成功音效（需要用户交互授权）
         */
        playSuccessSound() {
            // 注意：浏览器可能需要用户交互才能播放音频
            try {
                const audio = new Audio('data:audio/wav;base64,U3RlYWx0aCBzdWNjZXNz');
                audio.volume = 0.3;
                audio.play().catch(e => console.log('音频播放需要用户交互授权'));
            } catch (e) {
                console.log('音频播放失败');
            }
        },



        /**
         * 第四标签页-抽取记录
         */
        // 搜索记录
        handleSearchRollRecord(){
            this.rollRecordSearchForm.pageNum = 1
            this.queryRollRecords()
        },
        // 分页查询抽取记录
        queryRollRecords(){
            this.rollRecordTableLoading = true;   
            queryRollRecords(this.rollRecordSearchForm).then(res =>{
                this.rollRecordTableLoading = false;   
                if(res.data.code === 200) {
                    this.rollRecordList = res.data.rows ?  res.data.rows : [];
                    this.rollRecordListTotal = res.data.total ? res.data.total : 0;
                } else {
                    this.$message({
                        message: res.data.msg,
                        type: 'error'
                    });   
                }
            }).catch(err=>{
                this.rollRecordTableLoading = false;   
            })  
        },
        // 重置查询
        handleResetRollRecordSearchForm(){
            this.$refs.rollRecordSearchFormRef.resetFields();
            this.handleSearchRollRecord()
        },
        // 分页大小改变
        handleRollRecordSizeChange(val) {
            this.rollRecordSearchForm.pageSize = val
            this.rollRecordSearchForm.pageNum = 1
            this.queryRollRecords()
        },
        // 当前页改变
        handleRollRecordCurrentChange(val) {
            this.rollRecordSearchForm.pageNum = val
            this.queryRollRecords()
        },
    }
};
</script>
<style lang="less" scoped>
    .fatherCard {
        width: 1672px;
        position: fixed;
        height: 90vh;

        .exam-form {
            max-width: 900px;
            margin: 20px 0;
            padding-right: 24px;
        }

        .paper-group {
            margin-bottom: 8px;
            border-bottom: 1px dashed #ebeef5;
            //padding-bottom: 8px;
        }

        .paper-group:last-of-type {
        border-bottom: none;
        }

        .paper-group__content {
            width: 600px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .input-remove-wrapper {
                display: flex;
            }
        }

        .upload-tip {
            font-size: 12px;
            color: #909399;
            line-height: 1.4;
            margin-top: 4px;
        }

        .paper-group__content /deep/ .el-upload-list {
            min-width: 200px;
        }

        .paper-group__content /deep/ .el-form-item__content {
            //flex-wrap: wrap;
        }

        //抽取试卷

        .paper-extract-container {
            //padding: 20px;
        }

        .search-bar {
            padding: 15px;
            border-radius: 4px;
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
        }

.search-form {
  margin-bottom: 0;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}

.extract-dialog-content {
  max-height: 500px;
  overflow-y: auto;
}

.paper-list {
  border-radius: 4px;
}

.no-attachment {
  color: #c0c4cc;
  font-size: 12px;
}

/* 对话框内表格行高亮动画效果 */
/deep/ .dialog-table-row {
  transition: all 0.3s ease;
}

/deep/ .dialog-table-row:hover {
  background-color: #f5f7fa !important;
}
        
    /* 完全禁止所有行的 hover 变色 */
.el-table__row:hover > td {
  background-color: transparent !important;
}

    
    
    } 
</style>
